<div [ngSwitch]="match_status">
  <div *ngSwitchCase="'EXACT'">
    <div *ngIf="diagnostic?.length > 0" translate>therapyMatch.diagnostic</div>
    <key-value-card *ngFor="let item of diagnostic"
                    [configuration]="configuration['diagnostic']"
                    [isCard]="true"
                    [translationPrefix]="'therapyMatch'"
                    [data]="item.valueSet">`
    </key-value-card>
    <div *ngIf="prognostic?.length > 0" class="headline" translate>therapyMatch.prognostic</div>
    <key-value-card *ngFor="let item of prognostic"
                    [configuration]="configuration['prognostic']"
                    [isCard]="true"
                    [translationPrefix]="'therapyMatch'"
                    [data]="item.valueSet">`
    </key-value-card>
    <div *ngIf="therapeutic?.length > 0" class="headline" translate>therapyMatch.therapeutic</div>
    <key-value-card *ngFor="let item of therapeutic"
                    [configuration]="configuration['therapeutic']"
                    [isCard]="true"
                    [translationPrefix]="'therapyMatch'"
                    [data]="item.valueSet">`
    </key-value-card>
  </div>
  <div *ngSwitchCase="'PARTIAL'">
    <data-table
      [columnsData]="partialMatchTableData"
      [configuration]="configuration['partialMatchTableData']"
      [translationPrefix]="'therapyMatch'"></data-table>
  </div>
</div>
